module.exports = __webpack_public_path__ + "img/ic_km.7ed40f78.svg";